import { useCallback, useEffect, useState } from "react";
import {
  StorageScope,
  TValueForService,
} from "../../../../services/api/instances/storageApi/types/service_types";
import { useAppDispatch } from "../../../../services/redux/hooks/use-dispatch";
import { toggleAccordion } from "../../../Sidebar/redux/slice";
import {
  attachChildToParent,
  detachChildFromParent,
} from "../../../../app/state/storageObjectSlice/actions/actions";
import { setSelectedObjectId } from "../../../../app/state/storageObjectSlice/slice";
import { TAppMenu } from "../../../../app/state/menuSlice/types";
import { NormalizedStorageObject } from "../../../../services/api/instances/storageApi/types/object_types";
import { useStorageSelectors } from "../../../../app/state/storageObjectSlice/hook/use-storage-selectors";

export const useTransferObject = (
  service: StorageScope,
  sidebarAction: TAppMenu,
  objects: NormalizedStorageObject<TValueForService<StorageScope>>[],
  reset?: () => void,
) => {
  const dispatch = useAppDispatch();
  const { entities } = useStorageSelectors(service);
  const [folderId, setFolderId] = useState<string | null>(null);

  useEffect(() => {
    const targetObject = entities?.entities[sidebarAction?.info?.id ?? ""];
    setFolderId(targetObject?.parentId ?? null);
  }, [sidebarAction.info, entities]);

  const handleTransfer = useCallback(
    (id: string, ids?: string[]) => {
      const currentObject = objects.find((object) => object.id === id);
      if (currentObject) {
        dispatch(toggleAccordion(currentObject?.id as string));
        if (ids) {
          dispatch(
            attachChildToParent({
              childIds: ids,
              parentId: currentObject?.id ?? "",
              service,
            }),
          );
          dispatch(
            setSelectedObjectId({
              id: ids[ids.length - 1],
              service,
            }),
          );
        } else if (sidebarAction?.info?.id) {
          dispatch(
            attachChildToParent({
              childIds: [sidebarAction?.info?.id],
              parentId: currentObject?.id ?? "",
              service,
            }),
          );
          dispatch(
            setSelectedObjectId({
              id: sidebarAction?.info?.id,
              service,
            }),
          );
        }
        reset?.();
        return;
      } else if (!currentObject) {
        const item = ids && ids[0];
        const targetObject = objects.find(
          (object) =>
            object.id === sidebarAction?.info?.id || object.id === item,
        );
        const parentId =
          targetObject && targetObject?.parentId ? targetObject.parentId : "";
        dispatch(toggleAccordion(parentId));
        dispatch(
          detachChildFromParent({
            childIds: ids ? ids : [targetObject?.id ?? ""],
            parentId: parentId,
            service,
          }),
        );
        dispatch(
          setSelectedObjectId({
            id: ids ? ids[ids.length - 1] : (targetObject?.id ?? ""),
            service,
          }),
        );
        reset?.();
        return;
      }
    },
    [objects, sidebarAction.info],
  );

  return {
    folderId,
    handleTransfer,
  };
};
